import * as React from "react"
import { Container, Row } from "react-grid-system"
import NavigationTextButton from "../../atoms/buttons/NavigationTextButton"
import { theme } from "../../theme"
import { Spacer } from "../../atoms/spacers"
import { ArrowDropUpIcon } from "../../atoms/icons/ArrowDropUpIcon"
import styled from "styled-components"
import { ArrowDropDownIcon } from "../../atoms/icons/ArrowDropDownIcon"

interface Props extends React.PropsWithChildren {
  title: string
  isOpenDefault?: boolean
  active?: boolean
}

const SubMenu = styled.div`
  margin-left: ${(props) => props.theme.spacings.extreme};
`

const MobileNavSubMenu: React.FunctionComponent<Props> = ({ children, title, active, isOpenDefault }) => {
  const [isOpen, setIsOpen] = React.useState(isOpenDefault)

  return (
    <>
      <Container>
        <Row align="center" onClick={() => setIsOpen((isOpen) => !isOpen)}>
          <NavigationTextButton title={title} color={theme.colors.white} active={active} />
          <Spacer spacing={1} />
          {!isOpen ? <ArrowDropDownIcon color={theme.colors.white} /> : <ArrowDropUpIcon color={theme.colors.white} />}
        </Row>
      </Container>
      {isOpen && <SubMenu onClick={() => setIsOpen(false)}>{children}</SubMenu>}
    </>
  )
}

export default MobileNavSubMenu
